/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_Faq_A3Inputs */

const en_guide_json_syntax_errors_faq_a3 = /** @type {(inputs: Guide_Json_Syntax_Errors_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JavaScript object literals are more forgiving than JSON. They allow single quotes, unquoted keys, trailing commas, and comments. A strict JSON parser rejects all of those, which is why code that looks fine can still fail validation.`)
};

const ko_guide_json_syntax_errors_faq_a3 = /** @type {(inputs: Guide_Json_Syntax_Errors_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JavaScript 객체 리터럴은 JSON보다 관대합니다. 작은따옴표, 따옴표 없는 키, 후행 쉼표, 주석을 허용하죠. 엄격한 JSON 파서는 이 모두를 거부하므로 멀쩡해 보이는 코드도 검증에 실패할 수 있습니다.`)
};

const ja_guide_json_syntax_errors_faq_a3 = /** @type {(inputs: Guide_Json_Syntax_Errors_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JavaScript のオブジェクトリテラルは JSON より寛容です。シングルクォート、クォートなしのキー、末尾カンマ、コメントを許します。厳格な JSON パーサーはそのすべてを拒否するため、問題なく見えるコードでも検証に失敗することがあります。`)
};

/**
* | output |
* | --- |
* | "JavaScript object literals are more forgiving than JSON. They allow single quotes, unquoted keys, trailing commas, and comments. A strict JSON parser rejects..." |
*
* @param {Guide_Json_Syntax_Errors_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_faq_a3 = /** @type {((inputs?: Guide_Json_Syntax_Errors_Faq_A3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_Faq_A3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_faq_a3(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_faq_a3(inputs)
	return ja_guide_json_syntax_errors_faq_a3(inputs)
});